import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../data/store'
import { appActions } from '../../data/store/AppStore'
import { creditApplicationSelectors } from '../../data/store/CreditApplicationStore'
import { reportErrorToServer } from '../../error-logger'

const IFINANCE_WEBSITE_HOST = 'https://ifinancecanada.com'
const MEDICARD_WEBSITE_HOST = 'https://medicard.com'

function Header() {
  const { t, i18n } = useTranslation()
  const [displayDefaultLogo, setDisplayDefaultLogo] = React.useState(false)
  const targetLanguage = t('common.targetLanguage')
  const dispatch = useAppDispatch()
  const changeLanguage = (newLanguage: string) => {
    i18n.changeLanguage(newLanguage).catch(reportErrorToServer)
    dispatch(appActions.setLanguage(newLanguage))
  }

  const isMedicardHost = window.location.hostname.includes('medicard.com')

  const changeTitle = () => {
    document.title = String(process.env.REACT_APP_MEDICARD_MERCHANT_SITE_TITLE)
  }

  const changeFavicon = () => {
    window?.document
      // eslint-disable-next-line quotes
      ?.querySelector(`link[rel~='icon']`)
      ?.setAttribute('href', String(process.env.REACT_APP_MEDICARD_MERCHANT_SITE_FAVICON))
  }

  const currentMerchantId = useAppSelector(creditApplicationSelectors.getCurrentMerchantId)

  React.useEffect(() => {
    const browserLanguage: string = navigator.language.substring(0, 2)
    changeLanguage(browserLanguage)
    if (isMedicardHost) {
      changeTitle()
      changeFavicon()
    }
  }, [])

  const merchantIsMedicard = currentMerchantId === Number(process.env.REACT_APP_MEDICARD_MERCHANT_ID)
  const merchantIsIfinance = currentMerchantId === Number(process.env.REACT_APP_IFINANCE_MERCHANT_ID)
  const logoName = `${merchantIsMedicard ? `${currentMerchantId}_${i18n.language}` : currentMerchantId}.png`

  const needToHelpUrl =
    merchantIsMedicard || isMedicardHost
      ? `${MEDICARD_WEBSITE_HOST}/contact-us.php?lang=${i18n.language}`
      : `${IFINANCE_WEBSITE_HOST}/${i18n.language}/contact/`

  const backToUrl = () => {
    if (merchantIsMedicard || isMedicardHost) return `${MEDICARD_WEBSITE_HOST}?lang=${i18n.language}`
    return i18n.language === 'fr' ? `${IFINANCE_WEBSITE_HOST}/${i18n.language}/` : IFINANCE_WEBSITE_HOST
  }

  const defaultLogoIfNotFound = () => {
    if (isMedicardHost) return `${Number(process.env.REACT_APP_MEDICARD_MERCHANT_ID)}_${i18n.language}`
    return `${process.env.REACT_APP_IFINANCE_MERCHANT_ID}`
  }

  return (
    <header className="header" style={{ background: 'white' }}>
      <div className="wrap">
        <figure className="logo">
          <div className="left">
            <a
              href={merchantIsIfinance || merchantIsMedicard ? backToUrl() : undefined}
              target="_blank"
              className="btn-simple"
              rel="noreferrer"
            >
              <img
                style={{ maxHeight: '80px' }}
                id="logo"
                src={`${process.env.REACT_APP_BLOB_STORAGE_URL}/${logoName}`}
                onError={(e) => {
                  setDisplayDefaultLogo(true)
                  e.currentTarget.onerror = null
                  e.currentTarget.src = `${process.env.REACT_APP_BLOB_STORAGE_URL}/${defaultLogoIfNotFound()}.png`
                }}
                alt="iFinance Logo"
              />
            </a>
            {!merchantIsMedicard && !merchantIsIfinance && !displayDefaultLogo && (
              <img
                style={{ maxHeight: '80px' }}
                id="logo"
                src={`/images/in_partnership_${i18n.language}.svg`}
                alt="in partnership iFinance"
              />
            )}
          </div>
        </figure>
        <div className="right">
          <a href={needToHelpUrl} target="_blank" className="btn-simple" rel="noreferrer">
            {t<string>('common.needHelp')}
          </a>
          <a href={backToUrl()} className="btn-simple">
            {t<string>('common.backTo', { name: merchantIsMedicard || isMedicardHost ? 'Medicard' : 'iFinance' })}
          </a>
          <button type="button" className="btn btn-blue" onClick={() => changeLanguage(targetLanguage)}>
            {targetLanguage}
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header
